import React, { useState } from 'react';
type Tab = 'Signature Cocktails' | 'Starters & Sides' | 'Entrées';
const menuData: Record<Tab, Array<{
  name: string;
  description: string;
  price: string;
  image: string;
}>> = {
  'Signature Cocktails': [{
    name: 'Palm Wine Spritz',
    description: 'Traditional palm wine elevated with prosecco, fresh mint, and a hint of elderflower.',
    price: '$20',
    image: 'https://images.unsplash.com/photo-1514362545857-3bc16c4c7d1b?w=800&q=80'
  }, {
    name: 'Hibiscus Margarita',
    description: 'Zobo (hibiscus) infusion, premium tequila, fresh lime, with a chili-salt rim.',
    price: '$22',
    image: 'https://images.unsplash.com/photo-1536935338788-846bb9981813?w=800&q=80'
  }],
  'Starters & Sides': [{
    name: 'Suya Skewers',
    description: 'Spicy, peanut-crusted grilled beef skewers served with fresh red onions and tomatoes.',
    price: '$22',
    image: 'https://images.unsplash.com/photo-1528735602780-2552fd46c7af?w=800&q=80'
  }, {
    name: 'Kelewele & Puff Puff',
    description: 'Spiced fried plantains paired with our signature sweet, golden dough balls.',
    price: '$20',
    image: 'https://images.unsplash.com/photo-1604329760661-e71dc83f8f26?w=800&q=80'
  }],
  Entrées: [{
    name: 'Jollof Rice & Grilled Chicken',
    description: 'Classic smoky West African party rice served with perfectly charred, spiced chicken and fried plantains.',
    price: '$28',
    image: 'https://images.unsplash.com/photo-1604329760661-e71dc83f8f26?w=800&q=80'
  }, {
    name: 'Egusi Soup with Pounded Yam',
    description: 'Rich melon seed soup cooked with spinach, assorted meats, and palm oil, served with smooth pounded yam.',
    price: '$30',
    image: 'https://images.unsplash.com/photo-1515443961218-a51367888e4b?w=800&q=80'
  }]
};
export function CulinaryGrid() {
  const [activeTab, setActiveTab] = useState<Tab>('Signature Cocktails');
  const tabs: Tab[] = ['Signature Cocktails', 'Starters & Sides', 'Entrées'];
  return <section id="menu" className="bg-matte py-28 md:py-36 px-6 fade-section" data-id="element-24">
      <div className="max-w-7xl mx-auto" data-id="element-25">
        {/* Header */}
        <div className="text-center mb-16" data-id="element-26">
          <h2 className="font-sans text-sm tracking-mega-wide text-gold mb-4 uppercase" data-id="element-27">
            A Taste Of
          </h2>
          <h3 className="font-serif text-[38px] md:text-[50px] text-white" data-id="element-28">
            TEMPOO
          </h3>
        </div>

        {/* Tabs */}
        <div className="flex flex-wrap justify-center gap-8 md:gap-16 mb-16 border-b border-white/10 pb-4" data-id="element-29">
          {tabs.map(tab => <button key={tab} onClick={() => setActiveTab(tab)} className={`relative font-sans text-base uppercase tracking-widest pb-4 transition-colors duration-300 ${activeTab === tab ? 'text-white' : 'text-white/40 hover:text-white/70'}`} data-id="element-30">
              {tab}
              {activeTab === tab && <div className="absolute bottom-0 left-0 w-full h-0.5 bg-gold" data-id="element-31" />}
            </button>)}
        </div>

        {/* Grid Content */}
        <div className="flex flex-col gap-12 md:gap-24" data-id="element-32">
          {menuData[activeTab].map((item, index) => <div key={index} className={`grid grid-cols-1 md:grid-cols-2 gap-0 items-stretch ${index % 2 !== 0 ? 'md:flex-row-reverse' : ''}`} data-id="element-33">
              {/* Image */}
              <div className={`relative overflow-hidden group h-[400px] md:h-[500px] ${index % 2 !== 0 ? 'md:order-2' : ''}`} data-id="element-34">
                <img src={item.image} alt={item.name} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" data-id="element-35" />
              </div>

              {/* Text */}
              <div className={`bg-charcoal p-12 md:p-16 flex flex-col justify-center ${index % 2 !== 0 ? 'md:order-1' : ''}`} data-id="element-36">
                <h4 className="font-serif text-[26px] md:text-[32px] text-white mb-4" data-id="element-37">
                  {item.name}
                </h4>
                <p className="font-sans text-lg text-white/60 leading-relaxed mb-8 max-w-md" data-id="element-38">
                  {item.description}
                </p>
                <span className="font-sans text-gold text-xl tracking-wide" data-id="element-39">
                  {item.price}
                </span>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}